import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from "firebase/storage";

// Firebase 설정 객체
const firebaseConfig = {
  apiKey: "AIzaSyCSbq_y_AuFIbrS8-pjrEyCIUiQpWpb1f4",
  authDomain: "jungdari-d22b5.firebaseapp.com",
  projectId: "jungdari-d22b5",
  storageBucket: "jungdari-d22b5.appspot.com",
  messagingSenderId: "380416007645",
  appId: "1:380416007645:web:0b1e7f4201bbc4c7b02a34"
};


const app = initializeApp(firebaseConfig);

export const firestore = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'asia-northeast3');